import { CoreButton } from '@featuring-corp/components';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import InfluencerTable, {
	InfluencerTableProps,
} from '@components/report/influencer-table/InfluencerTable';

import { containerClass } from './style.css';

export type SimilarGroupProps<T extends string[]> = InfluencerTableProps<T>;

const SimilarGroupIg = <T extends string[]>(props: SimilarGroupProps<T>) => {
	const { t } = useTranslation('infReportInstagram');
	const available = !props.isLoading && !props.isError && !props.lackOfPermission;
	const [viewableSize, setViewableSize] = useState(5);

	const data = props.data ? props.data.slice(0, viewableSize) : [];

	return (
		<div className={containerClass}>
			<InfluencerTable
				header={[
					t('features.report.section-content.ig.similar-group.item.follower'),
					t('features.report.section-content.ig.similar-group.item.real-follower'),
				]}
				{...props}
				data={data}
			/>
			{available && props.data?.length > viewableSize && (
				<CoreButton
					buttonType="tertiary"
					size="sm"
					text={t(
						'features.report.section-content.ig.similar-group.influencer-table.button',
					)}
					onClick={() => setViewableSize(viewableSize + 5)}
				/>
			)}
		</div>
	);
};

export default SimilarGroupIg;
